import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[alternateClasstyling]',
})
export class AlternateClassStylingDirective implements AfterViewInit {
  @Input({ required: true }) baseClassName: string;
  @Input({ required: true }) alternateStyle: CSSStyleDeclaration;

  constructor(private elRef: ElementRef) {}

  ngAfterViewInit(): void {
    const htmlElement = this.elRef.nativeElement as HTMLElement;

    const matchingElement = htmlElement.querySelector('.' + this.baseClassName) as HTMLElement;

    Object.entries(this.alternateStyle).forEach(([key, value]) => {
      matchingElement.style[key] = value;
    });
  }
}
